export default __webpack_public_path__ + "static/media/sample radar.e1af70b4.PNG";